angular.module( 'acme.view.application.resources.facilities.assign', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.controller.resourceAssignment',
  'acme.view.application.resources.facilities.assign.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resourcesFacilitiesAssign = {
        name: 'application.resources.facilities.assign',
        url: '/assign',
        views: {
          "subview-main": {
            controller: 'ResourceAssignmentController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/resources/facilities/assign/assign.tpl.html'
          }
        },
        data: {
          pageTitle: 'Facility Assignment',
          rule: function(permits) {
            // Allow if state is not in exclusions array
            return (permits.indexOf('application.resources.facilities.assign') !== -1);
          }
        }
      };

    $stateProvider
      .state(resourcesFacilitiesAssign);
});
